export const STORE = {
  name: "DCS Electro",
  tagline: "Électroménagers & meubles à Montréal",
  address: "4100 rue Jarry E.",
  city: "Montréal, QC H1Z 2H4",
  phone: "+1 (514) 708-1010",
  phoneRaw: "+15147081010",
  email: "Dcservicesinfo@dcstravel.net",
  hours: "Lun–Sam : 9h – 18h",
  facebook: "https://www.facebook.com/dcselectros",
  friperie: "https://lylysstoreetfriperie.ca/",
  storePhoto: "/store.png",
  mapsEmbed: "https://www.google.com/maps?q=4100+Rue+Jarry+Est,+Montr%C3%A9al,+QC+H1Z+2H4&z=16&output=embed",
  mapsLink: "https://maps.app.goo.gl/UWA3xnxJ5RAXtAz19",
  agency: "https://carthisoft.com",
};
